import { render, staticRenderFns } from "./footBar.vue?vue&type=template&id=4f602c56&scoped=true"
import script from "./footBar.vue?vue&type=script&lang=js"
export * from "./footBar.vue?vue&type=script&lang=js"
import style0 from "./footBar.vue?vue&type=style&index=0&id=4f602c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f602c56",
  null
  
)

export default component.exports